import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { TtButton, TtTooltip } from '@23/react'

import './Forewarn.scss'

let peristantDismissed = false

const Forewarn = () => {
  const [wasDismissed, setWasDismissed] = useState(peristantDismissed)

  if (!navigator.userAgent.includes('Firefox/138')) return null

  if (wasDismissed) return null

  return (
    <div className="forewarn">
      <div className="forewarn-notice">
        <FormattedMessage
          defaultMessage="<paragraph>We have identified a potential performance problem on<bold>version 138</bold> of <bold>Firefox</bold> which can cause video tracks to not display properly in the webinar room.</paragraph>
          <paragraph>If you can, we recommend switching to a <tooltip>different browser</tooltip> while this is being resolved. We apologise for the inconvenience.</paragraph>
          <paragraph>Read more details at {link}.</paragraph>"
          values={{
            /* eslint-disable-next-line react/no-unstable-nested-components */
            bold: (...chunks) => <b>{chunks}</b>,
            /* eslint-disable-next-line react/no-unstable-nested-components */
            paragraph: (...chunks) => <p>{chunks}</p>,
            /* eslint-disable-next-line react/no-unstable-nested-components */
            tooltip: (...chunks) => (
              <TtTooltip placement="top">
                <span className="tooltip-trigger">{chunks}</span>
                <span slot="content" className="tooltip-content">
                  <FormattedMessage
                    defaultMessage="We recommend using either {lineBreak} Chrome, Edge or Safari"
                    values={{ lineBreak: <br /> }}
                  />
                </span>
              </TtTooltip>
            ),
            link: (
              <a
                target="_blank"
                href="https://www.twentythree.com/firefox138"
                rel="noreferrer"
              >
                {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
                {}
                twentythree.com/firefox138
              </a>
            ),
          }}
        />

        <TtButton
          size="small"
          pill
          onClick={() => {
            peristantDismissed = true
            setWasDismissed(true)
          }}
        >
          <FormattedMessage defaultMessage="I understand" />
        </TtButton>
      </div>
    </div>
  )
}

export { Forewarn }
